
import { useGLTF, useTexture, Sky, CubeCamera, Environment } from "@react-three/drei";
import * as THREE from 'three'




export default function House() {
    const { nodes } = useGLTF("./immeuble/immeuble.glb");

    const arbreTexture = useTexture('./immeuble/arbre.jpg')
    arbreTexture.flipY = false

    const arbreOpacityTexture = useTexture('./immeuble/arbre_opacity.png')
    arbreOpacityTexture.flipY = false

    const bordureTexture = useTexture('./immeuble/bordure.jpg')
    bordureTexture.flipY = false

    const centreTexture = useTexture('./immeuble/centre.jpg')
    centreTexture.flipY = false

    const jardinTexture = useTexture('./immeuble/jardin.jpg')
    jardinTexture.flipY = false

    const jeuEnfantsTexture = useTexture('./immeuble/jeu_enfants.jpg')
    jeuEnfantsTexture.flipY = false

    const moucharabiehTexture = useTexture('./immeuble/moucharabieh.jpg')
    moucharabiehTexture.flipY = false

    const murExterieurTexture = useTexture('./immeuble/mur_exterieur.jpg')
    murExterieurTexture.flipY = false

    const murMaison1Texture = useTexture('./immeuble/mur_maison_1.jpg')
    murMaison1Texture.flipY = false

    const murMaison2Texture = useTexture('./immeuble/mur_maison_2.jpg')
    murMaison2Texture.flipY = false

    const plante1Texture = useTexture('./immeuble/plante_1.jpg')
    plante1Texture.flipY = false

    const plante2Texture = useTexture('./immeuble/plante_2.jpg')
    plante2Texture.flipY = false

    const planteOpacityTexture = useTexture('./immeuble/plante_opacity.png')
    planteOpacityTexture.flipY = false

    const porteTexture = useTexture('./immeuble/porte.jpg')
    porteTexture.flipY = false

    const sol1Texture = useTexture('./immeuble/sol_1.jpg')
    sol1Texture.flipY = false

    const sol2Texture = useTexture('./immeuble/sol_2.jpg')
    sol2Texture.flipY = false

    const tableTexture = useTexture('./immeuble/table.jpg')
    tableTexture.flipY = false

    const toitTexture = useTexture('./immeuble/toit.jpg')
    toitTexture.flipY = false

    const vitresCadresTexture = useTexture('./immeuble/vitres_cadres.jpg')
    vitresCadresTexture.flipY = false




    return <><group dispose={null}>
        <CubeCamera resolution={256} frames={Infinity}>
            {(texture) => (<>
                <Environment map={texture} />
                <mesh
                    geometry={nodes.vitres.geometry}
                    position={[-9.96, 7.72, -8.63]}
                >
                    <meshStandardMaterial
                        transparent
                        roughness={0.2}
                    />
                </mesh>
            </>)}
        </CubeCamera>

        <mesh
            geometry={nodes.mur_maison_1.geometry}
            position={[-7.29, 2.3, -6.7]}
        >
            <meshBasicMaterial map={murMaison1Texture} />
        </mesh>
        <mesh
            geometry={nodes.toit.geometry}
            position={[0.04, 6.46, -4.87]}
        >
            <meshBasicMaterial map={toitTexture} />
        </mesh>
        <mesh
            geometry={nodes.sol_1.geometry}
            position={[-11.1, -0.22, 27.25]}
        >
            <meshBasicMaterial map={sol1Texture} />
        </mesh>
        <mesh
            geometry={nodes.table.geometry}
            position={[-5.02, 0.49, 27.58]}
        >
            <meshBasicMaterial map={tableTexture} />
        </mesh>
        <mesh
            geometry={nodes.mur_exterieur.geometry}
            position={[-0.05, -0.01, -4.47]}
        >
            <meshBasicMaterial map={murExterieurTexture} />
        </mesh>
        <mesh
            geometry={nodes.arbre_1.geometry}
            position={[17.59, 3.25, -16.25]}
        >
            <meshBasicMaterial
                map={arbreTexture}
                transparent
                alphaMap={arbreOpacityTexture}
                side={THREE.DoubleSide}
                alphaTest={0.5}
            />
        </mesh>
        <mesh
            geometry={nodes.arbre_3.geometry}
            position={[-15.87, 3.25, -16.25]}
        >
            <meshBasicMaterial
                map={arbreTexture}
                transparent
                alphaMap={arbreOpacityTexture}
                side={THREE.DoubleSide}
                alphaTest={0.5}
            />
        </mesh>
        <mesh
            geometry={nodes.arbre_2.geometry}
            position={[13.54, 3.76, -22.24]}
        >
            <meshBasicMaterial
                map={arbreTexture}
                transparent
                alphaMap={arbreOpacityTexture}
                side={THREE.DoubleSide}
                alphaTest={0.5}
            />
        </mesh>
        <mesh
            geometry={nodes.vitres_cadres.geometry}
            position={[10.04, 7.72, -8.63]}
        >
            <meshBasicMaterial map={vitresCadresTexture} />
        </mesh>
        <mesh
            geometry={nodes.plante_1.geometry}
            position={[12.27, 0.35, 1.78]}
        >
            <meshBasicMaterial
                map={plante1Texture}
                transparent
                alphaMap={planteOpacityTexture}
                side={THREE.DoubleSide}
                alphaTest={0.5}
            />
        </mesh>
        <mesh
            geometry={nodes.centre.geometry}
            position={[-0.05, -0.01, -4.47]}
        >
            <meshBasicMaterial map={centreTexture} />
        </mesh>
        <mesh
            geometry={nodes.jardin.geometry}
            position={[-0.05, -0.14, -13.96]}
        >
            <meshBasicMaterial map={jardinTexture} />
        </mesh>
        <mesh
            geometry={nodes.jeu_enfants.geometry}
            position={[13.04, 2.32, 28.64]}
        >
            <meshBasicMaterial map={jeuEnfantsTexture} />
        </mesh>
        <mesh
            geometry={nodes.mur_maison_2.geometry}
            position={[7.37, 2.3, -6.7]}
        >
            <meshBasicMaterial map={murMaison2Texture} />
        </mesh>
        <mesh
            geometry={nodes.porte.geometry}
            position={[0.05, 1.27, -1.58]}
        >
            <meshBasicMaterial map={porteTexture} />
        </mesh>
        <mesh
            geometry={nodes.sol_2.geometry}
            position={[10.99, -0.22, 27.25]}
        >
            <meshBasicMaterial map={sol2Texture} />
        </mesh>
        <mesh
            geometry={nodes.eau.geometry}
            position={[-0.05, -0.01, -4.47]}
        >
            <meshBasicMaterial />
        </mesh>
        <mesh
            geometry={nodes.bordure.geometry}
            position={[-0.05, -0.01, -4.47]}
        >
            <meshBasicMaterial map={bordureTexture} />
        </mesh>
        <mesh
            geometry={nodes.plante_2.geometry}
            position={[-6.31, 0.35, 1.78]}
        >
            <meshBasicMaterial
                map={plante2Texture}
                transparent
                alphaMap={planteOpacityTexture}
                side={THREE.DoubleSide}
                alphaTest={0.5}
            />
        </mesh>
        <mesh
            geometry={nodes.arbre_4.geometry}
            position={[-11.82, 3.76, -22.24]}
        >
            <meshBasicMaterial
                map={arbreTexture}
                transparent
                alphaMap={arbreOpacityTexture}
                side={THREE.DoubleSide}
                alphaTest={0.5}
            />
        </mesh>
        <mesh
            geometry={nodes.moucharabieh.geometry}
            position={[0.04, 7.91, -0.05]}
        >
            <meshBasicMaterial map={moucharabiehTexture} />
        </mesh>
    </group>
        <Sky />
    </>
}

useGLTF.preload("/immeuble.glb");